import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ContactContent extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            loading : 1, 
            name:'',
            email:'',
            phone:'',
            message:'',
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:"",
            sending:false
        }
        

    }

    handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (!this.state.name) {
            errors.name = 'Name is required';
          }  
          if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
        
        if (!this.state.message) {
            errors.message = 'Message is required';
          } 
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
            this.setState({sending:true});
             
            var data = {  name:this.state.name, 'email' :this.state.email, 'phone' :this.state.phone, 'message':this.state.message  }
            axios.post(api_base_url+"send_contact", data).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message});  
                }
                else{
                    
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Enquiry Successfully Sent."});
                    this.setState({name:'',email:'', phone:'',message:'', sending:false});
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

   

    render()
    { 
        const portals = JSON.parse(localStorage.getItem("portals"));
        const settings = JSON.parse(localStorage.getItem("settings"));
        
    return (
<div className='portals'>

    
<section className="section-padded">
  <div className="content">
    <h1 className="text-center">Client Portal</h1>
    <hr />
    <div className="cards">
     {portals.Client.map((item, index) => (  
      <div
        className="card aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-delay="0"
      >
        <span>
          <Link target="_blank" rel="noopener noreferrer" to={item.url}>
            <div className="card-logo">
              <img
                src={item.logo}
                alt={item.title}
              />
            </div>
            <div className="card-title">{item.title}</div>
          </Link>
        </span>
      </div>
     ))}
      </div>
</div>
</section>    

    
<section className="section-padded">
  <div className="content">
    <h1 className="text-center">Internal Portal</h1>
    <hr />
    <div className="cards">
     {portals.Internal.map((item, index) => (  
      <div
        className="card aos-init aos-animate"
        data-aos="fade-up"
        data-aos-duration="500"
        data-aos-delay="0"
      >
        <span>
          <Link target="_blank" rel="noopener noreferrer" to={item.url}>
            <div className="card-logo">
              <img
                src={item.logo}
                alt={item.title}
              />
            </div>
            <div className="card-title">{item.title}</div>
          </Link>
        </span>
      </div>
     ))}
      </div>
</div>
</section>    

 </div>
            
    );
}

}

export default ContactContent;